import Cookies from "js-cookie";

const USER_COOKIE = 'Brainhub:User';
const USER_LAST_ACCESS_DATE = "user:LastAccessDate";

let userCookie = Cookies.get(USER_COOKIE);
if (userCookie !== undefined) {
  userCookie = JSON.parse(decodeURIComponent(userCookie));
} else {
  userCookie = null;
}
function getCookieUserVar(variable) {
  if (userCookie !== null
    && userCookie.hasOwnProperty(variable)) {
    return userCookie[variable];
  }
  return undefined;
}

const id = getCookieUserVar("id");
const userType = getCookieUserVar("type") ?? 0;
const nick = getCookieUserVar("nick");
const encryptedEmail = getCookieUserVar('encryptedEmail');
const avatarUrl = getCookieUserVar("avatar");
const status = getCookieUserVar("status");
const statusText = getCookieUserVar("statusText");
const sex = getCookieUserVar("sex");
const province = getCookieUserVar("province");
const birthYear = getCookieUserVar("birthYear");
const registerDate = getCookieUserVar("registerDate");
const loginDate = getCookieUserVar("loginDate");
const accessDate = Cookies.get(USER_LAST_ACCESS_DATE);
const userAgent = window.navigator.userAgent;
const MOBILE_WIDTH = 768;
const isMobile = (Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < MOBILE_WIDTH);
const userAuthentication = "infolibre" // TODO: google, facebook, infolibre
const userPaymentMethod = getCookieUserVar("paymentMethod");
const userRenovationCount = getCookieUserVar("renovationCount");
const userSubscriptionMode = getCookieUserVar("subscriptionMode");
const userCampaign = getCookieUserVar("source");
const userSource = getCookieUserVar("medium");
const userMedium = getCookieUserVar("campaign");
const carrito = getCookieUserVar("carrito");
const tarjetaCaducada = getCookieUserVar("tarjetaCaducada");
const periodoGracia = getCookieUserVar("periodoGracia");

/**
 * Partner types:
 * Según el tipo de usuario, en web se obtendrán distintos beneficios,
 * a continuación se definen los tipos de usuario
 *
 * 0: usuario ajeno a la web
 * 1: usuario registrado
 * 3: Socio 60
 * 4: Socio estándar
 * 5: Socio 75
 */

/**
 * Todos los valores de los getters especials hacen lo definido aquí:
 * https://docs.google.com/spreadsheets/d/1UH3PvzKEYqNEVrT3kTsMvUIMOwJxXlzQ/edit#gid=1646535741
 * @type {{readonly isPartner: boolean, nick: *, avatarUrl: *, readonly isLogged: *, readonly getProfile: (string|*), id: *, userType: number}}
 */

const USER_TYPE_ANONYMOUS = 0;
const USER_TYPE_REGISTERED = 1;
const USER_TYPE_SUBSCRIBER_PLUS = 3;
const USER_TYPE_SUBSCRIBER = 4;
const USER_TYPE_SUBSCRIBER_PLUS_PLUS = 5;

const USER_STATUS_RENEWABLE = 0;
const USER_STATUS_NON_RENEWABLE = 1;
const USER_STATUS_EX_PARTNER = 2;

const user = {
  get isLogged() { return !!this.id },
  get isPartner() { return this.userType >= USER_TYPE_SUBSCRIBER_PLUS },
  id,
  userType,
  nick,
  encryptedEmail,
  avatarUrl,
  status,
  statusText,
  get profile() {
    if (this.status === USER_STATUS_EX_PARTNER) {
      return 'ex Socio';
    }
    switch (this.userType) {
      case 0:
        return 'Anónimo';
      case 1:
        return 'Registrado';
      case 3:
        return 'Socio 60';
      case 4:
        return 'Socio estándar';
      case 5:
        return 'Socio 75';
      default:
        return '';
    }
  },
  sex,
  province,
  birthYear,
  registerDate,
  loginDate,
  accessDate,
  userAgent,
  get state() {
    return this.isLogged ? 'logado' : 'no logado';
  },
  userAuthentication,
  userPaymentMethod,
  userRenovationCount,
  userSubscriptionMode,
  userCampaign,
  userSource,
  userMedium,
  isMobile,
  swgLogin: function (url, callbackUrl) {
    $.ajax(url, {
      xhrFields: {
        withCredentials: true
      }
    }).done(function () {
      window.location.href = callbackUrl + '&rd=' + window.location.href;
    });
  },
  carrito,
  tarjetaCaducada,
  periodoGracia,
};

window.app = {
  user,
  getCookieUserVar: getCookieUserVar
}

export {
  USER_TYPE_ANONYMOUS,
  USER_TYPE_REGISTERED,
  USER_TYPE_SUBSCRIBER_PLUS,
  USER_TYPE_SUBSCRIBER,
  USER_TYPE_SUBSCRIBER_PLUS_PLUS,
  USER_STATUS_RENEWABLE,
  USER_STATUS_NON_RENEWABLE,
  USER_STATUS_EX_PARTNER
}
export default user;
